import { Component } from '@angular/core';

@Component({
    selector: 'app-pin-page-update',
    templateUrl: './pin-page-update.component.html',
    styleUrls: ['./pin-page-update.component.css'],
    standalone: false
})
export class PinPageUpdateComponent {

}
